import React from 'react';
import { DownloadNavbar } from './download-navbar';
import { Footer } from './footer-section';
import { Component } from './button-1';

const DownloadPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <DownloadNavbar />
      
      <main className="flex-grow pt-20 overflow-y-auto">
        <div className="container mx-auto px-4 py-8 md:py-16">
          <section className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-serif font-bold mb-4">Download Caude</h1>
            <p className="text-lg text-muted-foreground">Available for macOS, Windows, and Linux.</p>
            <div className="mt-8 flex justify-center">
              <Component />
            </div>
          </section>
          
          <section className="mb-16">
            <div className="border border-border rounded-lg">
              <div className="flex justify-between items-center p-4 border-b border-border cursor-pointer">
                <div className="flex items-center space-x-2">
                  <span className="font-bold text-lg">1.7</span>
                  <span className="bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300 text-xs font-medium px-2.5 py-0.5 rounded-full">Latest</span>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-muted-foreground" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="p-4 md:p-6 grid grid-cols-1 md:grid-cols-3 gap-6">
                <div>
                  <h3 className="font-semibold mb-4 flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="mr-2 h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M6.625 2.655A9 9 0 0119 11a1 1 0 11-2 0 7 7 0 00-9.625-6.492 1 1 0 11-.75-1.853zM4.662 4.959A1 1 0 014.75 6.37 6.97 6.97 0 003 11a1 1 0 11-2 0 8.97 8.97 0 012.25-5.953 1 1 0 011.412-.088z" clipRule="evenodd" />
                      <path fillRule="evenodd" d="M5 11a5 5 0 1110 0 1 1 0 11-2 0 3 3 0 10-6 0c0 1.677-.693 3.208-1.805 4.319a1 1 0 11-1.414-1.414C5.665 13.055 6 12.047 6 11a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                    Windows
                  </h3>
                  <div className="space-y-3">
                    <div className="flex justify-between items-center text-muted-foreground">
                      <span>Windows (x64) Installer</span>
                      <a 
                        href="/downloads/kaya-windows-x64-installer.exe" 
                        className="text-foreground hover:text-primary"
                        download
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                      </a>
                    </div>
                    <div className="flex justify-between items-center text-muted-foreground">
                      <span>Windows (x64) Portable</span>
                      <a 
                        href="/downloads/kaya-windows-x64-portable.zip" 
                        className="text-foreground hover:text-primary"
                        download
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
                {/* Removed macOS and Linux sections as those files are not currently available */}
              </div>
              <div className="p-4 border-t border-border">
                <a href="#" className="text-sm text-muted-foreground hover:text-foreground flex items-center">
                  View release notes 
                  <svg xmlns="http://www.w3.org/2000/svg" className="text-sm ml-1 h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </a>
              </div>
            </div>
          </section>
          
          <section className="space-y-2">
            <div className="border border-border rounded-lg">
              <div className="flex justify-between items-center p-4 cursor-pointer">
                <span className="font-medium">1.6</span>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-muted-foreground" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
            <div className="border border-border rounded-lg">
              <div className="flex justify-between items-center p-4 cursor-pointer">
                <span className="font-medium">1.5</span>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-muted-foreground" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
            <div className="border border-border rounded-lg">
              <div className="flex justify-between items-center p-4 cursor-pointer">
                <span className="font-medium">1.4</span>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-muted-foreground" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
            <div className="border border-border rounded-lg">
              <div className="flex justify-between items-center p-4 cursor-pointer">
                <span className="font-medium">1.3</span>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-muted-foreground" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
            <div className="border border-border rounded-lg">
              <div className="flex justify-between items-center p-4 cursor-pointer">
                <span className="font-medium">1.2</span>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-muted-foreground" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
          </section>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default DownloadPage;